
<div
  class="view-contact-form ws-min-height-1000 ws-typography bg-ws-white q-pb-5xl"
>
  <div class="top-section q-pb-4xl q-px-md">
    <div class="col-12 text-center">
      <div class="title-wrapper q-mx-auto">
        <h2 :class="[mobile ? 'q-mb-sm' : 'q-mb-xl']">
          {{ $t(mainMessage.title) }}
        </h2>
        <p v-if="mainMessage.info" class="q-mb-none">
          {{ $t(mainMessage.info) }}
        </p>
        <ws-message v-if="step === 1" type="alert" path="general" />
      </div>
    </div>
  </div>

  <sidebar-layout class="rest-section q-px-md">
    <template
      v-if="[CF_USECASE.SERVER, CF_USECASE.MONITORING].includes(usecase)"
    >
      <!-- intetntional period 1 to disaply price for one month only -->
      <product-info
        v-if="productInfo"
        :product-info="productInfo"
        class="q-mb-md"
        :period="model.period"
        @period-change="model.period = $event"
      />
      <sidebar-layout-item
        v-else-if="loadingInfo || !productInfo"
        class="product-info q-mb-md"
      >
        <q-skeleton
          v-if="loadingInfo"
          type="QRange"
          animation="fade"
          height="200px"
        />
        <ws-message v-if="!productInfo" type="alert" :path="scfInfoPath" />
      </sidebar-layout-item>
    </template>

    <template v-if="loadingOptions">
      <sidebar-layout-item class="contact-form-step1 q-mb-md">
        <q-skeleton type="QRange" animation="fade" height="800px" />
      </sidebar-layout-item>
    </template>

    <template v-if="productOptions">
      <contact-form-additional
        v-if="usecase !== CF_USECASE.MANAGEMENT"
        v-model="model"
        :usecase="usecase"
        :product-options="productOptions"
        :in-edit="step === 1"
        class="q-mb-md"
        @continue="step = 2"
        @edit="step = 1"
      />

      <transition name="slide-fade-vertical">
        <contact-form-user-data
          v-if="step === 2"
          ref="userData"
          v-model="model"
          class="q-mb-md"
          :usecase="usecase"
          :product-options="productOptions"
        />
      </transition>
    </template>

    <sidebar-layout-item
      :hidden="loadingOptions || productOptions"
      class="q-mb-md"
    >
      <ws-message type="alert" :path="cfOptionsPath" />
    </sidebar-layout-item>

    <template v-slot:side>
      <properties-summary
        :info="productInfo"
        :options="productOptions"
        :model="model"
        :path="
          usecase === CF_USECASE.MONITORING
            ? 'product.properties.monitoring'
            : undefined
        "
        :properties="summaryProperties[usecase]"
        :simple-items="
          [CF_USECASE.MANAGEMENT, CF_USECASE.MONITORING].includes(usecase)
        "
        :default-price="[CF_USECASE.MANAGEMENT].includes(usecase) ? 0 : null"
      >
        <template v-if="productInfo && usecase === CF_USECASE.SERVER" v-slot:info>
          {{ productInfo.cpuName }}, {{ productInfo.ram }}GB,
          {{ productInfo.primaryDrives }}
        </template>
        <template v-if="step === 2">
          <ws-button
            class="q-mt-md"
            :type="WsButtonEnum.Type.PRIMARY"
            :disable="checkoutInProgress"
            full-width
            @click="submit"
          >
            {{ $t('summary.finish_order') }}
          </ws-button>
          <ws-message type="alert" path="general" />
        </template>

        <template v-slot:empty>
          <div class="row items-center no-wrap q-mt-md q-pt-sm">
            <div class="emoji q-mr-lg">
              😢
            </div>
            <div class="ws-typo-button text-ws-base120">
              {{ $t('product.properties.monitoring.basic.label') }}
            </div>
          </div>
        </template>
      </properties-summary>
    </template>
  </sidebar-layout>
</div>
